import React, { useState } from 'react';
import { Parallax } from 'react-parallax';

import clsx from 'clsx';

import { useTranslation } from '@crehana/i18n';

import { createImgixPlaceholder, CustomNextImage } from '@crehana/next';

import { Col, Container, Row } from '@crehana/ui';

import { useMediaQuery } from '@crehana/react-hooks';

import { WHY_CREHANA_CARDS } from '../constants';

import {
  containerHeight,
  containerWidthLg,
  containerWidthMd,
  StyledCardContainer,
  StyledContainer,
  StyledImage,
  StyledLeftBar,
  StyledTextContainer,
} from './WhyCrehanaDesktop.styles';

const WhyCrehanaDesktop = () => {
  const { t } = useTranslation();
  const [cardInView, setCardInView] = useState(0);
  const { matches: isLg } = useMediaQuery('lg');

  const handleCardChange = (percentage: number) => {
    if (percentage <= 1.2) {
      setCardInView(0);
    }
    if (percentage > 1.2) {
      setCardInView(1);
    }
    if (percentage > 1.4) {
      setCardInView(2);
    }
    if (percentage > 1.6) {
      setCardInView(3);
    }
  };

  return (
    <Container>
      <Row>
        <Col>
          <StyledContainer
            className={'flex flex-col items-center mx-auto relative '}
          >
            {/* Left bar */}
            <Parallax
              style={{
                height: `calc(${containerHeight} * 4 + 144px)`,
                width: isLg ? containerWidthLg : containerWidthMd,
              }}
              renderLayer={percentage => {
                handleCardChange(percentage);
                const shouldBeFixed = percentage > 1 && percentage <= 1.7;
                return (
                  <StyledCardContainer
                    style={{
                      marginBottom: percentage > 1.7 ? 240 : 0,
                      bottom: !isLg && !shouldBeFixed ? '60px' : 0,
                      transition: !isLg ? '.5s' : 'none',
                    }}
                    className={clsx('w-full mx-auto bg mt-144', {
                      'absolute inset-0': percentage < 1,
                      'absolute right-0 left-0': percentage > 1.7,
                      'fixed inset-0': shouldBeFixed,
                    })}
                  >
                    <StyledLeftBar
                      className={clsx(
                        'w-8 overflow-hidden absolute left-0 top-0 bottom-0 my-auto z-3',
                      )}
                      accentColor={WHY_CREHANA_CARDS[cardInView].accentColor}
                      cardInView={cardInView}
                    />
                  </StyledCardContainer>
                );
              }}
            />
            <div className="absolute top-0 mt-144">
              {WHY_CREHANA_CARDS.map(({ description, title, image }, index) => {
                return (
                  <StyledCardContainer
                    key={`why-crehana-card-${index}`}
                    className="flex flex-row items-center relative -z-1"
                  >
                    <StyledTextContainer className="flex flex-col">
                      <h3
                        className="font-gil text-20 uppercase text-primary-main font-semibold mt-24 mb-40"
                        style={{
                          letterSpacing: 1.5,
                        }}
                      >
                        {t('WHY_CREHANA_TITLE')}
                      </h3>
                      <h4 className="font-h3 text-40 leading-48 mb-32">
                        {t(title)}
                      </h4>
                      <p className="font-body2 leading-28">{t(description)}</p>
                    </StyledTextContainer>

                    <StyledImage className="flex-shrink-0 relative">
                      <CustomNextImage
                        src={image}
                        blurDataURL={createImgixPlaceholder(image)}
                        layout="fill"
                        alt="Benefit illustration"
                        objectFit="contain"
                        objectPosition="center"
                        placeholder="blur"
                      />
                    </StyledImage>
                  </StyledCardContainer>
                );
              })}
            </div>
          </StyledContainer>
        </Col>
      </Row>
    </Container>
  );
};

export default React.memo(() => <WhyCrehanaDesktop />);
